import axios from "axios";
import { Fragment } from "react";

export default function(err: Error, fallback: string) {
  if(axios.isAxiosError(err)) {
    if(err?.response?.data?.message) {
      if (typeof err.response.data.message === 'string')
        return <span className='text-sm'>{err.response.data.message}</span>
      if (Array.isArray(err.response.data.message))
        return <span className='text-sm'>{err.response.data.message.map((x: string) => <Fragment key={x}>{x}<br/></Fragment>)}</span>
    }
  }
  return <span className='text-sm'>{fallback}</span>
}